import { useEffect } from 'react';
import { useMemo, useState } from 'react';

export function useSwallowDocumentFinished() {
  useEffect(() => {
    const handler = (e: PromiseRejectionEvent) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const r: any = e?.reason;
      const isDocFinished =
        r?.response?.status === 400 &&
        r?.response?.data?.error === 'document-finished';
      const isDirectDownloadNotSupported =
        r?.response?.status === 400 &&
        r?.response?.data?.error === 'direct-download-not-supported';
      if (isDocFinished || isDirectDownloadNotSupported) {
        e.preventDefault();
      }
    };
    window.addEventListener('unhandledrejection', handler);
    return () => window.removeEventListener('unhandledrejection', handler);
  }, []);
}

export function useOptimisticFinished(
  enabledProp: boolean,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  documentResult?: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  session?: any
) {
  const finishedFromContext = useMemo<boolean | undefined>(() => {
    const fromDoc = documentResult?.result?.finished;
    const fromSess = session?.finished;
    return typeof fromDoc === 'boolean'
      ? fromDoc
      : typeof fromSess === 'boolean'
        ? fromSess
        : undefined;
  }, [documentResult, session]);

  const serverFinished = finishedFromContext ?? enabledProp;
  const [uiFinished, setUiFinished] = useState<boolean>(serverFinished);

  useEffect(() => {
    setUiFinished(serverFinished);
  }, [serverFinished]);

  return { uiFinished, setUiFinished, serverFinished };
}
